import { Footer } from "../footer/footer";
import { TCNavbar } from "../navbar/navbar";
import { SetupStage } from "./stage";
import { SetupTOCCard, PreviousButton, NextButton } from "./toc";
import { Authenticate } from "../authenticate";
import { Container, Row, Col, Spinner } from "solid-bootstrap";
import { fetchOnce } from "../../util/fetch";
import { Show, createSignal,  } from "solid-js";
import { Service } from "../../service/device/setup";
import { useParams } from "@solidjs/router";

export function DeviceSetup(props) {
    const [device, isLoaded, isError] = fetchOnce(() => Service.getDevice(props.deviceUUID));

    return <>
        <TCNavbar />
        <Container class="d-flex flex-column gap-5 pt-3 pb-3">
            <Show when={!isLoaded()}>
                <Row>
                    <Col>
                        <Spinner animation="border"/>
                    </Col>
                </Row>
            </Show>
            <Show when={isLoaded()}>
                <Row>
                    <Col>
                        <SetupTOCCard device={device()} setStageName={props.setStageName} stageName={props.stageName} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <SetupStage device={device()} stageName={props.stageName} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <PreviousButton device={device()} stageName={props.stageName} setStageName={props.setStageName} />
                    </Col>
                    <Col>
                        <NextButton device={device()} stageName={props.stageName} setStageName={props.setStageName} />
                    </Col>
                </Row>
            </Show>
        </Container>
        <Footer />
    </>
}

export function DeviceSetupRoute(props) {
    const params = useParams();
    const [stageName, setStageName] = createSignal("googlemaps");
    return <Authenticate>
        <DeviceSetup stageName={stageName()} setStageName={setStageName} deviceUUID={params.uuid} />
    </Authenticate>;
}